import { render, staticRenderFns } from "./VehicleSourceInformationField.vue?vue&type=template&id=f080d62a&scoped=true"
import script from "./VehicleSourceInformationField.vue?vue&type=script&lang=ts"
export * from "./VehicleSourceInformationField.vue?vue&type=script&lang=ts"
import style0 from "./VehicleSourceInformationField.vue?vue&type=style&index=0&id=f080d62a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f080d62a",
  null
  
)

export default component.exports